import Modal from 'bootstrap/js/dist/modal';

let clickOutside = null;
let clickFvListBtn = null;

export default function favoritesControl() {
  const addClass = 'favorites-control--add';
  const delClass = 'favorites-control--del';
  const readyClass = 'is-ready';
  const currentItemClass = 'favorites-control__item--current';
  const fvControl = document.querySelector('.favorites-control');

  if (!fvControl) return;

  const fvPopup = fvControl.querySelector('.favorites-control__popup');
  const newButton = fvControl.querySelector('.favorites-control__new-button');
  const delButton = fvControl.querySelector('.favorites-control__del-button');
  const fvModalEl = fvControl.querySelector('.favorites-control__new-modal');

  const fvModal = new Modal(fvModalEl);

  function checkPosition() {
    const fvBtn = fvPopup.currentFvCheckbox?.closest('.btn-favorites');
    if (!fvBtn) return;

    const yOffset = 8;
    const paddings = 10;
    const fvBtnRect = fvBtn.getBoundingClientRect();
    const fvPopupRect = fvPopup.getBoundingClientRect();
    const fvPopupRectHalfWidth = fvPopupRect.width / 2;

    const fvBtnTop = fvBtnRect.top + window.scrollY;
    const fvBtnLeft = fvBtnRect.left + window.scrollX;

    const left = fvBtnLeft + fvBtnRect.width / 2;
    let offsetLeft = 0;
    let top = fvBtnTop + fvBtnRect.height + yOffset;

    if (fvBtnRect.top + fvBtnRect.height + yOffset + fvPopupRect.height + paddings >= window.innerHeight) {
      top = fvBtnTop - fvPopupRect.height - yOffset;
    }

    const rightOverflow = left + fvPopupRectHalfWidth + paddings;
    const leftOverflow = left - fvPopupRectHalfWidth - paddings;

    if (rightOverflow > document.body.clientWidth) {
      offsetLeft = document.body.clientWidth - rightOverflow;
    } else if (leftOverflow < 0) {
      offsetLeft = Math.abs(leftOverflow);
    } else {
      offsetLeft = 0;
    }

    fvPopup.style.top = `${top}px`;
    fvPopup.style.left = `${left}px`;
    fvPopup.style.marginLeft = offsetLeft ? `${offsetLeft}px` : null;
  }

  function closePopup() {
    const fvItems = fvPopup.querySelectorAll('.favorites-control__item[data-projectboardid]');

    fvPopup.classList.remove('show');
    fvPopup.style.display = null;

    // fvButtons.forEach((btn) => {
    //   btn.value = null;
    // });

    window.removeEventListener('resize', checkPosition);
    window.removeEventListener('scroll', checkPosition);
    document.removeEventListener('click', clickOutside);
    fvPopup.removeEventListener('click', clickFvListBtn);
    fvPopup.classList.remove(addClass, delClass);
    fvItems.forEach((item) => {
      item.classList.remove(currentItemClass);
    });
  }

  clickFvListBtn = (evt) => {
    const btn = evt.target.closest('.favorites-control__btn');
    if (!btn) return;

    const listId = btn.getAttribute('data-projectboardid');

    // console.log(btn.value, btn.entityId);
    fvPopup.currentFvCheckbox.checked = true;
    fvPopup.currentFvCheckbox.setAttribute('data-projectboardid', listId);
    fvPopup.currentFvCheckbox.dispatchEvent(new Event('change'));
    fvPopup.currentFvCheckbox.dispatchEvent(new Event('input'));
    closePopup();
  };

  clickOutside = (evt) => {
    const isClickInside = fvPopup.contains(evt.target);
    const trigger = fvPopup.currentFvCheckbox.closest('.btn-favorites');
    if (!isClickInside && !trigger.isSameNode(evt.target.closest('.btn-favorites'))) {
      closePopup();
    }
  };

  function openPopup(fvCheck) {
    const fvItems = fvPopup.querySelectorAll('.favorites-control__item[data-projectboardid]');

    fvPopup.currentFvCheckbox = fvCheck;

    if (!fvPopup.currentFvCheckbox.checked) {
      fvItems.forEach((item) => {
        if (item.getAttribute('data-projectboardid') === fvCheck.getAttribute('data-projectboardid')) {
          item.classList.add(currentItemClass);
        }
      });
    }

    fvPopup.style.display = 'block';
    checkPosition();
    window.addEventListener('resize', checkPosition);
    window.addEventListener('scroll', checkPosition);
    fvPopup.addEventListener('click', clickFvListBtn);
    fvPopup.classList.add('show');
    setTimeout(() => {
      document.addEventListener('click', clickOutside);
    }, 0);
  }

  newButton.addEventListener('click', () => {
    fvModal.show();
    closePopup();
  });

  if (delButton) {
    delButton.addEventListener('click', () => {
      fvPopup.currentFvCheckbox.checked = false;
      fvPopup.currentFvCheckbox.dispatchEvent(new Event('change'));
      fvPopup.currentFvCheckbox.dispatchEvent(new Event('input'));
      closePopup();
    });
  }

  window.enableFavControls = () => {
    const favCtrl = document.querySelectorAll(`.btn-favorites:not(.${readyClass})`);
    favCtrl.forEach((fv) => {
      fv.classList.add(readyClass);
    });
  };

  window.disableFavControls = () => {
    const favCtrl = document.querySelectorAll(`.btn-favorites.${readyClass}`);
    favCtrl.forEach((fv) => {
      fv.classList.remove(readyClass);
    });
  };

  window.enableFavControls();

  /* favoriteBtns.forEach((el) => {
    const fvCheck = el.querySelector('input.btn-favorites__check');

    // fvCheck.addEventListener('click', (evt) => {
    //   // if (!fvCheck.checked) return;
    //   let className = addClass;
    //
    //   evt.preventDefault();
    //   if (!fvCheck.checked) {
    //     className = delClass;
    //   }
    //
    //   fvPopup.classList.add(className);
    //
    //   if (fvPopup.classList.contains('show') && fvCheck.isSameNode(fvPopup.currentFvCheckbox)) {
    //     closePopup();
    //   } else {
    //     openPopup(fvCheck);
    //   }
    // });

    fvCheck.addEventListener('change', () => {
      console.log('fvCheck checked', fvCheck.checked);
    });
  }); */

  const addElementsObserver = new MutationObserver(() => {
    window.enableFavControls();
  });

  addElementsObserver.observe(document.body, { subtree: true, childList: true });

  document.body.addEventListener('click', (evt) => {
    const { target } = evt;

    if (!target.classList.contains('btn-favorites__check')) return;

    let className = addClass;

    evt.preventDefault();
    if (!target.checked) {
      className = delClass;
    }

    fvPopup.classList.add(className);

    if (fvPopup.classList.contains('show') && target.isSameNode(fvPopup.currentFvCheckbox)) {
      closePopup();
    } else {
      openPopup(target);
    }
  });
}
